import React from 'react';
import R from 'ramda';
import { connect } from 'react-redux';
import { firstError } from 'common/validation';
import { getErrors } from 'common/stepReducerUtil';
import { SHOW_CANCEL_SUBMISSION_DIALOG } from 'submission/submissionActions';
import { getStep } from 'common/selectors';
import * as steps from 'common/steps';
import fileHandles from '../fileHandles';

import {
  COMPLETE_STEP,
  setCopyrightFile,
  setDissertationFile,
} from 'file-upload/fileUploadActions';

import {
  getCopyrightFileName,
  getDissertationFileName,
} from 'file-upload/fileUploadReducer';

import FileUploadInput from 'general-components/FileUploadInput';
import StepPanelButtonBar from 'general-components/StepPanelButtonBar';
import styles from './FileUpload.css';

const getCopyrightFile = name => (name ? fileHandles.copyright : null);
const getDissertationFile = name => (name ? fileHandles.dissertation : null);

const FileUploadStepPanel = ({
  copyrightFile,
  dissertationFile,
  errors,
  onCancel,
  onCopyrightFileChanged,
  onDissertationFileChanged,
  onNext,
}) =>
  <div className={styles.stepPanel}>
    <h1>File Upload</h1>

    <h3 className={!R.isNil(errors.dissertationFile) ? styles.error : ''}>
      Upload a PDF or ePUB of your thesis or dissertation
    </h3>

    <p className={styles.label}>.pdf or .epub</p>

    <FileUploadInput
      className={styles.fileUpload}
      value={dissertationFile}
      accept=".pdf,.epub"
      onChange={onDissertationFileChanged}
      error={firstError(errors, 'dissertationFile')}
    />

    <h3>
      Do you have any copyright permissions documents to submit? (optional)
    </h3>

    <p className={styles.label}>
      If copyright permission documents are included in your dissertation/thesis
      file, you do not need to submit them separately.
    </p>

    <p className={styles.label}>.pdf</p>

    <FileUploadInput
      className={styles.fileUpload}
      value={copyrightFile}
      accept=".pdf"
      onChange={onCopyrightFileChanged}
      error={firstError(errors, 'copyrightFile')}
    />

    <StepPanelButtonBar onNext={onNext} onCancel={onCancel} />
  </div>;

const mapState = R.pipe(
  getStep(steps.FILE_UPLOAD),
  R.applySpec({
    copyrightFile: R.pipe(getCopyrightFileName, getCopyrightFile),
    dissertationFile: R.pipe(getDissertationFileName, getDissertationFile),
    errors: getErrors,
  }),
);

const mapDispatch = dispatch => ({
  onCancel: () => dispatch({ type: SHOW_CANCEL_SUBMISSION_DIALOG, show: true }),
  onCopyrightFileChanged: file => dispatch(setCopyrightFile(file)),
  onDissertationFileChanged: file => dispatch(setDissertationFile(file)),
  onNext: () => dispatch({ type: COMPLETE_STEP }),
});

export default connect(mapState, mapDispatch)(FileUploadStepPanel);



// WEBPACK FOOTER //
// ./src/file-upload/components/FileUpload.js